import React from 'react';
import {
  BrowserRouter as Router, Route, Switch, Redirect, withRouter
} from 'react-router-dom';
import './App.css';
import Layout from './Components/Layout';
import LoginPage from './Pages/LoginPage';
import DashboardRefundsPage from './Pages/DashboardRefundsPage';

import { parseToken } from './Auth';

class App extends React.Component {
  render() {
    return <div className="App">
      <Router>
        <Switch>
          <Route path="/login" exact>
            <Layout hasMaxWidth={true}>
              <LoginPage />
            </Layout>
          </Route>
          <Route path="/refund/:id" render={(r) => {
            let id = r.match.params.id;
            return parseToken() ?
              <Layout><DashboardRefundsPage /></Layout> :
              <Redirect to={{
                pathname: '/login',
                state: { id: id }
            }}   />;
          }} />
          <Route path="/" render={() => {
            return parseToken() ?
              <Layout><DashboardRefundsPage /></Layout> :
              <Redirect to="/login" />;
          }} />
          
        </Switch>
      </Router>
    </div>
  }
}


export default withRouter(App);
